import { makeStyles } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';
import { componentDimensions } from 'UI/constants/dimensions';

export const useDrawerStyles = makeStyles(theme => ({
  drawerLarge: {
    width: componentDimensions.drawer.large.width,
    overflowY: 'hidden',
    [theme.breakpoints.down('sm')]: {
      width: '80%'
    }
  }
}));

export const ScopeSelectorContainer = styled('div')(({ theme }) => ({
  margin: theme.spacing(3),
  width: '40%',
  [theme.breakpoints.down('sm')]: {
    width: '90%'
  }
}));
